
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface PopularTagsProps {
  tags?: string[];
  selectedTags?: string[];
  onTagToggle?: (tag: string) => void;
}

const PopularTags: React.FC<PopularTagsProps> = ({ 
  tags = ['Music', 'Vocals', 'Beats', 'Cover Art', 'Remix', 'Instrumental', 'Demo', 'WIP', 'Final', 'Archive'],
  selectedTags = [], 
  onTagToggle = () => {} 
}) => {
  return (
    <div className="p-4 border rounded-lg mt-6">
      <h3 className="font-medium text-sm mb-2">Popular Tags</h3>
      <div className="flex flex-wrap gap-2">
        {tags.slice(0, 10).map(tag => (
          <Badge 
            key={tag} 
            variant={selectedTags.includes(tag) ? 'default' : 'outline'}
            className="cursor-pointer"
            onClick={() => onTagToggle(tag)}
          >
            {tag}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default PopularTags;
